import { Component, Inject, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';

@Component({
    selector: 'tt-ni',
    templateUrl: './ni.component.html',
    styleUrls: ['./ni.component.css'],
    standalone: false,
})
export class NiComponent {
    public number = '0';

    private inputNumber = '';

    private pressedDecimal = false;

    private navigator?: TTViewNavigator;

    constructor(
        @Inject('niService') private niService: NiSharedInputService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public typeNumber(value: string): void {
        if (value === '.') {
            if (this.pressedDecimal) return;

            this.inputNumber += value;
            this.pressedDecimal = true;
        } else {
            this.inputNumber += value;
        }

        this.number = this.inputNumber;
    }

    public deleteNumber(): void {
        this.number = '0';
        this.inputNumber = '';
        this.pressedDecimal = false;
    }

    public async saveToPrevious(): Promise<void> {
        this.niService.inputNumber.number = this.number;
        await this.navigator?.back();
    }
}

interface NiSharedInputService {
    inputNumber: {
        number: string;
        webPageName: string;
    };
}
